import React, { useState, useEffect, useRef } from 'react';

interface PhoneInputProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    prefix?: string;
    name?: string;
    className?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
    value = '',
    onChange,
    placeholder = 'e.g: 3001234567',
    prefix = '+92',
    name = 'phoneNumber',
    className = ''
}) => {
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (value.startsWith(prefix)) {
            setInputValue(value.slice(prefix.length));
        } else {
            setInputValue(value);
        }
    }, [value, prefix]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newValue = e.target.value.replace(/\D/g, "");
        if (newValue.length > 10) return;

        setInputValue(newValue);

        if (onChange) {
            onChange(`${prefix}${newValue}`)
        }
    };

    const handleContainerClick = () => inputRef.current?.focus();

    return (
        <div className={`phone-input-container ${className}`}>
            <label className="form-label">Phone Number (WhatsApp)</label>
            <div className="phone-input-wrapper" onClick={handleContainerClick}>
                <span className="phone-prefix">{prefix}</span>
                <input
                    ref={inputRef}
                    type="tel"
                    className="phone-input"
                    name={name}
                    value={inputValue} 
                    onChange={handleChange}
                    placeholder={placeholder}
                    maxLength={10}
                />
            </div>
        </div>
    );
};

export default PhoneInput;
